import { projectId } from '../services/firebase';

export const API_BASE_URL = `https://us-central1-${projectId}.cloudfunctions.net`;

export const API_AUTH_HEADERS = {
    Authorization: 'rD!ORaqjfQc2m)fl$oRwX~*t7Cn0?%',
  };
